/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type HeartsDropdownContainer_app$ref = any;
type MoneyRaisedContainer_app$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserMenuContainer_app$ref: FragmentReference;
declare export opaque type UserMenuContainer_app$fragmentType: UserMenuContainer_app$ref;
export type UserMenuContainer_app = {|
  +$fragmentRefs: MoneyRaisedContainer_app$ref & HeartsDropdownContainer_app$ref,
  +$refType: UserMenuContainer_app$ref,
|};
export type UserMenuContainer_app$data = UserMenuContainer_app;
export type UserMenuContainer_app$key = {
  +$data?: UserMenuContainer_app$data,
  +$fragmentRefs: UserMenuContainer_app$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "UserMenuContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "MoneyRaisedContainer_app",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "HeartsDropdownContainer_app",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '11167d894b76cdefb45f89ba0086923a';
module.exports = node;
